import React, { useEffect } from 'react';
import './Styles/App.css';
import './Styles/Product.css';
import './Styles/media.css';
import './Styles/custom.css';
import Main from './Main';
import LogoutTimer from '../src/Components/ReusableComponent/LogoutTimer';
import './Styles/customSingleStore.css';
import './Styles/customPaymentCart.css';
import './Styles/global.scss';
import { ToastContainer } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import SeoControl from './Components/SEO/SeoControl';
import MkonnektDiscountSync from './Components/MkonnektDiscountSync/MkonnektDiscountSync';
import {
  clearCheckoutAdjustmentDraftForMerchantChange,
  getCheckoutMerchantIdFromPath,
} from './utils/checkoutAdjustmentDraft';
function App() {
  const location = useLocation();

  useEffect(() => {
    let merchantId = getCheckoutMerchantIdFromPath(location.pathname);

    if (!merchantId && location.pathname.toLowerCase() === '/store') {
      try {
        merchantId = localStorage.getItem('merchant_id');
      } catch {
        merchantId = null;
      }
    }

    if (merchantId) {
      clearCheckoutAdjustmentDraftForMerchantChange(merchantId);
    }
  }, [location.pathname]);

  // hello word
  // const navigate = useNavigate();

  // useEffect(() => {
  //   const url = location.pathname;
  //   const bool = location.pathname.includes('Findstore');
  //   if (bool) {
  //     const modifiedUrl = url.replace('/Findstore', '');
  //     navigate(modifiedUrl);
  //   }
  // }, [location]);
  //  useEffect(() => {
  //     const isDirectVisit = document.referrer === '' && window.history.length <= 2;
  //     if (isDirectVisit) {
  //       sessionStorage.setItem('directMerchantVisit', 'true');
  //     } else {
  //       sessionStorage.setItem('directMerchantVisit', 'false');
  //     }
  //   }, []);

  return (
    <>
      <SeoControl />
      <LogoutTimer />
      <MkonnektDiscountSync />
      <Main />
      {/* <NewMain /> */}
      <ToastContainer />
    </>
  );
}

export default App;
